import { useTypedParams } from '@sorare/routing';

import { CollectionLayout } from '@sorare/gameplay/src/components/collections/CollectionLayout';

import { LayoutParams } from './__generated__/routeParams';

const FootballCollectionLayout = () => {
  const { slug, collection } = useTypedParams<LayoutParams>();
  return (
    <CollectionLayout collection={collection} userSlug={slug} fromMyClub />
  );
};

export default FootballCollectionLayout;
